import { FixedObject } from "gatsby-image";

const fixedObjectKeys = ["width", "height", "src", "srcSet"] as const;
type FixedObjectKey = typeof fixedObjectKeys[number];
const typeByFixedObjectKey: Record<FixedObjectKey, string> = {
  width: "number",
  height: "number",
  src: "string",
  srcSet: "string",
};

export function isFixedObject(value: any): value is FixedObject {
  return fixedObjectKeys.reduce((memo, key) => {
    // ESLint wants us to type every check out by hand. No, thanks. I'll let
    // the computer check each property's type for me.
    // eslint-disable-next-line valid-typeof
    return typeof value?.[key] === typeByFixedObjectKey[key] && memo;
  }, true as boolean);
}
